import React from 'react'
import { Helmet } from 'react-helmet';

export default function StructuredBase() {
  // ToDo: make url property a dynamic value, utilzing an env variable to handle different locales
  return (
    <Helmet>
      <script type="application/ld+json">
        {`{ 
          "@context": "http://schema.org", 
          "@type": "WebSite",
          "name": "Thermacell Repellents.",
          "headline": "Mosquito Repellent and Tick Control",
          "description": "The Best Mosquito Repellents",
          "url": "https://www.thermacell.com",
          "image": "https://cdn.shopify.com/s/files/1/2537/3762/files/Logo-4x_400x200.png",
          "sameAs": [
            "https://www.facebook.com/ThermacellOutdoors/",
            "https://www.instagram.com/thermacell/",
            "https://www.youtube.com/user/Thermacell",
            "https://twitter.com/thermacell"
          ],
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.thermacell.com/search",
            "query-input": "required type=search"
          }
        }`}
      </script>

      <script type="application/ld+json">
        {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "name": "Thermacell Repellents",
          "image": "https://cdn.shopify.com/s/files/1/2537/3762/files/Logo-4x_400x200.png",
          "logo": "https://cdn.shopify.com/s/files/1/2537/3762/files/Logo-4x_400x200.png",
          "description": "The Best Mosquito Repellents",
          "url": "https://www.thermacell.com",
          "contactPoint": [{
            "@type": "ContactPoint",
            "telephone": "+1-781-541-6900",
            "contactType": "customer service",
            "areaServed": [
              "US"
            ],
            "contactOption": [
              "TollFree"
            ],
            "availableLanguage": [
              "English"
            ]
          }],
          "sameAs": [
            "https://www.facebook.com/ThermacellOutdoors/",
            "https://www.instagram.com/thermacell/",
            "https://www.youtube.com/user/Thermacell",
            "https://twitter.com/thermacell"
          ]
        }`}
      </script>
    </Helmet>
  )
}
